/* eslint-disable lodash/prefer-lodash-method */

const replaceStringByContext = (stringToReplace: string, context: any) =>
  stringToReplace.replace(/{{(.*?)}}/g, (_, group) =>
    group
      .trim()
      .split(/[.[\]]/)
      .reduce((prevState: any, contextKey: any) => [...prevState, ...[contextKey]], [])
      .reduce((prevState: any, contextKey: any) => prevState[contextKey] || 'unavailableData', context)
  )

export const interpolate = (paramValue: string, context: any) => replaceStringByContext(paramValue, context)
